var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 50,
  height: 30,
  viewBox: "0 0 37 31"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M35.68 5.909H.852a.391.391 0 0 1-.391-.392V.822C.462.606.637.43.853.43H35.68c.216 0 .391.175.391.39v4.696a.391.391 0 0 1-.39.392zM1.243 5.126h34.02V1.213H1.244v3.913zM35.68 30.24H.852a.391.391 0 0 1-.391-.391v-4.696c0-.216.175-.391.391-.391H35.68c.216 0 .391.175.391.391v4.696a.391.391 0 0 1-.39.391zm-34.436-.783h34.02v-3.913H1.244v3.913z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.602 25.529h-.125L3.592 16.083a.383.383 0 0 1-.266-.368.383.383 0 0 1 .266-.376L31.484 5.165a.391.391 0 0 1 .501.235.383.383 0 0 1-.219.509L4.891 15.69l26.875 9.079a.383.383 0 0 1 .25.493.391.391 0 0 1-.414.266z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.586 25.529a.395.395 0 0 1-.11-.783l27.9-8.319L4.845 5.91a.391.391 0 0 1-.227-.501.391.391 0 0 1 .54-.235l28.573 10.91c.158.06.259.215.25.383a.4.4 0 0 1-.273.36L4.704 25.513l-.118.016z"
}))));
export default __webpack_public_path__ + "teg/media/vertical-loading.393a1e14.svg";
export { SvgComponent as ReactComponent };